import { css } from 'styled-components';
import { colors } from '@ardoq/design-tokens';

const dashedGradient = (color: string) => css`
  background-image: linear-gradient(
    to right,
    ${color} 33%,
    rgba(255, 255, 255, 0) 0%
  );
`;

const underlinedElStyle = css`
  cursor: default;
  position: relative;
  display: inline-block;
`;

const underlineStyle = css`
  content: ' ';
  display: block;
  width: 100%;
  bottom: 0;
  position: absolute;
  left: 0;
  height: 2px;
`;

const underline = css`
  ${underlinedElStyle}
  &::after {
    ${underlineStyle}
  }
`;

export const popoverUnderline = css`
  ${underline};
  &::after {
    ${dashedGradient(colors.grey700)}
    background-position: bottom;
    background-size: 4px 1px;
    background-repeat: repeat-x;
  }
  &:hover {
    &::after {
      ${dashedGradient(colors.grey900)}
    }
  }
`;
